import * as React from 'react';
import isOverdue from '../utils/isOverdue';
import LinkedEmailEntity from './LinkedEmailEntity';
import Todo from '../store/schema/Todo';
import { ControlIcons } from 'owa-control-icons';
import { formatMonthDay } from 'owa-datetime';
import { Icon } from 'office-ui-fabric-react/lib/Icon';
import { observer } from 'mobx-react';
import { clickEmail } from '../actions/todoActions';

let styles = require('./TodoListItemInfo.scss');
let classNames = require('classnames/bind').bind(styles);

export interface TodoListItemInfoProps {
    todo: Todo;
}

@observer
export default class TodoListItemInfo extends React.Component<TodoListItemInfoProps, {}> {
    render() {
        const { IsReminderOn, DueDateTime, LinkedEmail } = this.props.todo;
        return (
            <>
                <div>
                    {LinkedEmail && (
                        <LinkedEmailEntity emailId={LinkedEmail.Id} onClick={clickEmail} />
                    )}
                </div>
                <div className={styles.taskItemInfo}>
                    {DueDateTime && this.renderDueDate()}
                    {IsReminderOn && this.renderReminder()}
                </div>
            </>
        );
    }

    private renderDueDate(): JSX.Element {
        const { DueDateTime } = this.props.todo;
        if (!DueDateTime) {
            return null;
        }

        return (
            <span
                className={classNames(styles.dueDate, {
                    overdue: isOverdue(DueDateTime),
                })}>
                <Icon iconName={ControlIcons.Event} className={styles.icon} />
                <span className={styles.label}>
                    <span className={styles.date}>{formatMonthDay(DueDateTime)}</span>
                </span>
            </span>
        );
    }

    private renderReminder(): JSX.Element {
        const { IsReminderOn, ReminderDateTime } = this.props.todo;
        if (!IsReminderOn || !ReminderDateTime) {
            return null;
        }

        return (
            <span className={styles.reminder}>
                <Icon iconName={ControlIcons.AlarmClock} className={styles.icon} />
                <span className={styles.label}>
                    <span className={styles.date}>{formatMonthDay(ReminderDateTime)}</span>
                </span>
            </span>
        );
    }
}
